import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vuejquery from 'vue-jquery'
import jquery from 'jquery'
import './assets/scss/index.scss'
global.jquery = jquery
global.$ = jquery
Vue.use(BootstrapVue)
Vue.use(vuejquery)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
